import './FlyoutScreen.css'
import { useMediaQuery } from 'react-responsive';

import {useEffect, useState} from 'react';

import FlyoutPlan from "./FlyoutPlan.jsx";
import FlyoutMap from "./FlyoutMap.jsx";

import { getFlyouts, createFlyout, updateFlyout, deleteFlyout } from '../assets/virtual-flyout/flyout-service.js';
import {setMSLTemperature, setWind} from '../assets/virtual-flyout/weather-service.js';
import FlyoutRoster from "./FlyoutRoster.jsx";
import {FlyoutPlanContext} from "./flyout-plan-context.js";
import { getPlan, createPlan, updatePlan, deletePlan, getAllPlans } from '../assets/virtual-flyout/flyout-service.js';
import FlyoutCard from "./FlyoutCard.jsx";
import {FlyoutForm} from "./FlyoutForm.jsx";

import PlaneController from "../redux/planeController.js";
import {addLogEntry, setSpeed, startSim, stopSim, tick} from "../redux/simSlice.js";
import {useDispatch, useSelector} from "react-redux";

import Slider from '@mui/material/Slider';

import {formatTime} from "../assets/common/format-utils.js";
import FlyoutPlaneState from "./FlyoutPlaneState.jsx";
export default function FlyoutScreen() {

  const isMobile = useMediaQuery({ query: '(max-width: 30em)' });

  const [flyoutSchedule, setFlyoutSchedule] = useState([]);
  const [activeFlyout, setActiveFlyout] = useState(null);

  const [state, setState] = useState("LIST");
  const [plan, setPlan] = useState();
  const [allPlans, setAllPlans] = useState([]);
  const [activeDay, setActiveDay] = useState(null);
  function fetchFlyouts() {
    getFlyouts()
    .then(data => {
      setFlyoutSchedule(data);
    })
    .catch(error => {
      console.error('Error fetching flyouts:', error);
    });
  }

  useEffect(() => { 
    fetchFlyouts();
  }, []);

  useEffect(() => {
    if (activeFlyout !== null) {
      const activeFlyoutObj = flyoutSchedule[activeFlyout];
      fetchPlan(activeFlyoutObj);
      fetchAllPlans(activeFlyoutObj);
      setMSLTemperature(activeFlyoutObj.weather.temperature);
      setWind(activeFlyoutObj.weather.wind.heading, activeFlyoutObj.weather.wind.speed);
    } else {
        setState("LIST");
    }
  } , [activeFlyout, flyoutSchedule]);

  function handleSelectFlyout(flyoutIndex) {
    setActiveFlyout(flyoutIndex);
  }

  function fetchPlan(flyoutObj) {
    getPlan(flyoutObj)
      .then(plan => {
        if (!plan || Object.keys(plan).length === 0) {
          setState("VIEW");
        } else {
          setPlan(plan);
          setState("PLAN");
        }
      })
      .catch(error => {
        console.error('Failed to fetch plan:', error);
      });
  }

  function fetchAllPlans(flyoutObj) {
    getAllPlans(flyoutObj)
      .then(plans => {
        setAllPlans(plans);
      })
      .catch(error => {
        console.error('Failed to fetch all plans:', error);
      });
  }

  function joinFlyout(plane) {
    createPlan(flyoutSchedule[activeFlyout], plane)
      .then(() => {
        fetchPlan(flyoutSchedule[activeFlyout]);
      })
      .catch(error => {
        console.error('Failed to join flyout:', error);
      });
  }

  function handleUnjoinFlyout() {
    deletePlan(flyoutSchedule[activeFlyout])
      .then(() => {
        setPlan(null);
        setAllPlans([]);
        fetchPlan(flyoutSchedule[activeFlyout]);
      })
      .catch(error => {
        console.error('Failed to unjoin flyout:', error);
      });
  }

  function ctxPlanSwitchDay(day) {
    setActiveDay(day);
  }

  function ctxPlanAddLeg(leg, indexBefore) {
    setPlan((prev) => {
      const newDays = [...prev.days];
      const newDay = JSON.parse(JSON.stringify(
          newDays.find(day => day.name === activeDay)
      ));
      newDay.legs.splice(indexBefore, 0, leg);
      newDays[newDays.findIndex(day => day.name === activeDay)] = newDay;
      const newPlan = {...prev, days: newDays};
      updatePlan(flyoutSchedule[activeFlyout], newPlan);
      return newPlan;
    });
  }

  function ctxPlanModifyLeg(index, leg) {
    setPlan((prev) => {
      const newDays = [...prev.days];
      const newDay = {...newDays.find(day => day.name === activeDay)};
      newDay.legs[index] = leg;
      newDays[newDays.findIndex(day => day.name === activeDay)] = newDay;
      const newPlan = {...prev, days: newDays};
      updatePlan(flyoutSchedule[activeFlyout], newPlan);
      return newPlan;
    });
  }

  function ctxPlanDeleteLeg(index) {
    setPlan((prev) => {
      const newDays = [...prev.days];
      const newDay = JSON.parse(JSON.stringify(
        newDays.find(day => day.name === activeDay)
      ));
      newDay.legs.splice(index, 1);
      newDays[newDays.findIndex(day => day.name === activeDay)] = newDay;
      const newPlan = {...prev, days: newDays};
      updatePlan(flyoutSchedule[activeFlyout], newPlan);
      return newPlan;
    });
  }

  function ctxPlanUnregister() {
    handleUnjoinFlyout();
  }

  function switchToFlyoutsList() {
    setActiveFlyout(null);
    setPlan(null);
    setAllPlans([]);
    setState("LIST");
  }

  function handleAddFlyout(newFlyout) {
    createFlyout(newFlyout)
        .then(response => {
            const flyoutWithId = {
                ...newFlyout,
                flyoutId: response.flyoutId
            };
            setFlyoutSchedule(prevSchedule => [flyoutWithId, ...prevSchedule]);
            setState("LIST");
        })
        .catch(error => {
            console.error('Failed to create flyout:', error);
        });
  }

  function handleModifyFlyout(updatedFlyout) {
    updateFlyout(updatedFlyout)
        .then(response => {
            setFlyoutSchedule(prevSchedule => 
                prevSchedule.map(flyout => 
                    flyout.flyoutId === updatedFlyout.flyoutId ? updatedFlyout : flyout
                )
            );
            setState("VIEW");
        })
        .catch(error => {
            console.error('Failed to update flyout:', error);
        });
  }

  function handleDeleteFlyout(flyoutIndex) {
    deleteFlyout(flyoutSchedule[flyoutIndex].flyoutId)
        .then(() => {
            setFlyoutSchedule(prevSchedule => prevSchedule.filter((_, index) => index !== flyoutIndex));
            setActiveFlyout(null);
            setState("LIST");
        })
        .catch(error => {
            console.error('Failed to delete flyout:', error);
        });
  }

  const simState = useSelector(state => state.sim);
  const dispatch = useDispatch();
  const SIM_INTERVAL = 1000;

  function createPlaneWithFlightPlan(plan, simDate) {
    const plane = new PlaneController({
      planeId: plan.plane.reg,
      type: plan.plane.type,
      pob: plan.plane.PoB,
      onEvent: (message) => handleEvent(plan.plane.reg, message),
      onEnd: () => handlePlaneFinished(plan.plane.reg)
    });
    const day = plan.days[0];
    plane.moveTo(day.startPoint);
    for (let leg of day.legs) {
      if (leg.type === "flight") {
        const [hours, minutes] = leg.departureTime.split(':');
        const departureTimestamp = new Date(simDate);
        departureTimestamp.setHours(parseInt(hours), parseInt(minutes), 0, 0);
        plane.takeOff(leg.segments[0].from, null, departureTimestamp);
        plane.climb(leg.segments[0].altitude * 1000);
        plane.interceptTrack(leg.segments[0].from, leg.segments[0].to);
        for (let i = 0; i < leg.segments.length; i++) {
          if (i < leg.segments.length - 1) {
            // not the last segment
            if (leg.segments[i].altitude < leg.segments[i + 1].altitude) {
              plane.flyDirectClimb(leg.segments[i].to, leg.segments[i + 1].altitude * 1000);
            } else if (leg.segments[i].altitude > leg.segments[i + 1].altitude) {
              plane.flyDirectDescend(leg.segments[i].to, leg.segments[i + 1].altitude * 1000);
            } else {
              plane.flyDirect(leg.segments[i].to);
            }
          } else {
            // last segment
            plane.flyDirectDescend(leg.segments[i].to, 2000);
            plane.visualCircuit(leg.segments[i].to);
          }
        }
      } else {
        plane.refuel(leg.location, Number(leg.fuelQty));
      }
    }
    return plane;
  }

  const [simulatedPlanes, setSimulatedPlanes] = useState([]);
  useEffect(() => {
    if (state === "SIMULATE" && simulatedPlanes.length === 0) {
      handleSimulateEnd();
    }
  }, [simulatedPlanes, state]);  

  useEffect(() => {
      if (simState.mode === "RUNNING") {
        const timer = setInterval(() => {
            simulatedPlanes.forEach(plane => plane.tick(SIM_INTERVAL * simState.speed));
            dispatch(tick(SIM_INTERVAL * simState.speed));
        }, SIM_INTERVAL / simState.speed);
        return () => clearInterval(timer);
      }
  }, [simState.mode, simState.speed, dispatch]);

  const events = [];
  function handleEvent(planeId, message) {
      if (!events.includes(message)) {
          dispatch(addLogEntry({planeId: planeId, message: message}));
          events.push(message);
      }
  }

  function getStartTime(plan) {
    const day = plan.days[0];
    const flightLegs = day.legs.filter(leg => leg.type === "flight");
    const firstFlight = flightLegs.reduce((earliest, leg) => {
      if (!earliest || leg.departureTime < earliest.departureTime) {
        return leg;
      }
      return earliest;
    }, null);
    const startTime = firstFlight.departureTime.split(":");
    return [parseInt(startTime[0]), parseInt(startTime[1])];
  }
    
  function handleSimulateStart() {
    const simDay = flyoutSchedule[activeFlyout].days[0];
    const simDate = new Date(simDay.date);

    if (plan) { // if simulating an active plan (single user)
      const [hours, minutes] = getStartTime(plan);
      simDate.setHours(hours, minutes, 0, 0);
      setSimulatedPlanes([createPlaneWithFlightPlan(plan, simDate)]);
    } else if (allPlans.length > 0) { // if simulating all submitted plans (multiple users)
      const earliestStartTime = allPlans.reduce((earliest, plan) => {
        const [hours, minutes] = getStartTime(plan);
        const currentMinutes = hours * 60 + minutes;
        const earliestMinutes = earliest[0] * 60 + earliest[1];
        return currentMinutes < earliestMinutes ? [hours, minutes] : earliest;
      }, getStartTime(allPlans[0]));
      simDate.setHours(earliestStartTime[0], earliestStartTime[1], 0, 0);
      setSimulatedPlanes(allPlans.map(plan => createPlaneWithFlightPlan(plan, simDate)));
    }
    dispatch(startSim(simDate.valueOf()));
    setState("SIMULATE");
  }

  function handlePlaneFinished(planeId) {
    setSimulatedPlanes((prev) => prev.filter(plane => plane.planeId !== planeId));
  }

  function handleSimulateEnd() {
    dispatch(stopSim());
    if (!plan) {
      setState("VIEW");
    } else {
      setState("PLAN");
    }
  }

  const [selectedPlaneId, setSelectedPlaneId] = useState(null);

  return <FlyoutPlanContext.Provider value={{ plan, allPlans, activeDay, selectedPlaneId, ctxPlanSwitchDay, ctxPlanAddLeg,
    ctxPlanModifyLeg, ctxPlanDeleteLeg, ctxPlanUnregister }}>
    <div className="flyout-screen">
      <div className="flyout-plan-container">
        <div className="flyout-top-panel">

          {/* Top menu */}
          <div className="flyout-top-panel-buttons">
            {state === "LIST" &&
              <button className={"flyout-plan-button"} onClick={() => setState("ADD")}>Add Flyout</button>
            }
            {["VIEW", "PLAN"].includes(state) &&
              <button className="flyout-plan-button" onClick={switchToFlyoutsList}>Back to list</button>
            }
            {state === "VIEW" && <>
              <button className="flyout-plan-button" onClick={() => setState("MODIFY")}>Modify</button>
              <button className="flyout-plan-button" onClick={() => handleDeleteFlyout(activeFlyout)}>Delete</button>
            </>}
            {state === "PLAN" &&
              <button className="flyout-plan-button" onClick={handleUnjoinFlyout}>Unjoin</button>
            }
            {["VIEW", "PLAN"].includes(state) &&
              <button className="flyout-plan-button" onClick={handleSimulateStart}>Simulate</button>
            }
            {state === "SIMULATE" &&
              <button className="flyout-plan-button" onClick={handleSimulateEnd}>End Simulation</button>
            }
          </div>
          <div className="flyout-top-panel-controls">
            {state === "SIMULATE" && <>
              <div className="flyout-sim-control-container">
                <p className="flyout-sim-clock-label">{formatTime(simState.time)}</p>
              </div>
              <div className="flyout-sim-slider-container">
                <p className="flyout-sim-slider-label">1x</p>
                <Slider
                  value={simState.speed}
                  onChange={(event, value) => dispatch(setSpeed(value))}
                  min={1} max={10} step={1}
                  sx={{
                    color: '#ccbfb2',
                    '& .MuiSlider-root': {
                      padding: '0',
                      margin: '0'
                    },
                    '& .MuiSlider-track': { backgroundColor: '#ffefdf' }
                  }}
                  valueLabelDisplay="off"
                />
                <p className="flyout-sim-slider-label">100x</p>
              </div>
            </>}
          </div>
        </div>
        {state === "LIST" &&
          <div className="flyout-list-cards">
            {flyoutSchedule.map((flyout, index) => (
              <FlyoutCard key={index} flyout={flyout} onSelect={() => handleSelectFlyout(index)} />
            ))}
          </div>
        }
        {["VIEW", "PLAN", "SIMULATE"].includes(state) && activeFlyout !== null &&
            <FlyoutCard flyout={flyoutSchedule[activeFlyout]} />
          }
        {state === "ADD" && <FlyoutForm onSubmit={handleAddFlyout} onCancel={switchToFlyoutsList}/>}
        {state === "MODIFY" && activeFlyout !== null && (
          <FlyoutForm
          flyout={flyoutSchedule[activeFlyout]}
          onSubmit={handleModifyFlyout}
          onCancel={() => setState("VIEW")}
          />
        )}
        {["VIEW", "SIMULATE"].includes(state) && !plan &&
          <FlyoutRoster 
            flyout={flyoutSchedule[activeFlyout]} 
            onRegister={joinFlyout}
            selectedPlaneId={selectedPlaneId}
            onSelectPlane={setSelectedPlaneId}
          />
        }
        {["VIEW", "SIMULATE"].includes(state) && selectedPlaneId &&
          <FlyoutPlaneState planeId={selectedPlaneId}/>}
        {["PLAN", "SIMULATE"].includes(state) && plan &&
          <FlyoutPlan/>}
      </div>
      {!isMobile ? <FlyoutMap onSelectPlane={setSelectedPlaneId}/> : null}
    </div>
  </FlyoutPlanContext.Provider>
}
